import { formatDateTime, toIso } from '../../lib/formatDate';
import { useAnchorCell } from './anchorCell';

/**
 * A date in the viewer's local timezone, monospaced so columns align — reference §4.
 * Always wrapped in `<time>` so the machine-readable instant travels with the display text.
 *
 * In the anchor column the value darkens, exactly as `<TextCell>` does there: the anchor is
 * the row's click target, and a table whose first column happens to be a date (the audit
 * trail) must not lose that affordance.
 */
export function DateCell({
  value,
  fallback = 'Never',
}: {
  value: string | null | undefined;
  fallback?: string;
}) {
  const anchor = useAnchorCell();

  if (!value) {
    return <span className="text-xs text-slate-400">{fallback}</span>;
  }

  return (
    <time
      dateTime={toIso(value)}
      className={`block font-mono tabular-nums text-xs ${
        anchor ? 'font-medium text-blue-500' : 'text-slate-500'
      }`}
    >
      {formatDateTime(value)}
    </time>
  );
}
